// removed by extract-text-webpack-plugin
module.exports = {"dropdown-submenu":"dropdown-submenu","dropdown-menu":"dropdown-menu","category-children":"category-children"};


//////////////////
// WEBPACK FOOTER
// ./components/category/style.css
// module id = ./components/category/style.css
// module chunks = 1